import toStandardDateString from "./toStandardDateString"

export default function (dateRange) {
  return `${
    dateRange.startDate
      ? `start_date=${toStandardDateString(dateRange.startDate)}`
      : ""
  }${dateRange.startDate && dateRange.endDate ? "&" : ""}${
    dateRange.endDate
      ? `end_date=${toStandardDateString(dateRange.endDate)}`
      : ""
  }`
}
